module.exports = __webpack_public_path__ + "media/images/loghi/icon_media-8487e82067fa67e812cafa4bb395fce6.svg";